/**
* View Model to handle presentation of open availability
*
* @class OpenAvailabilityViewModel
*/
function OpenAvailabilityViewModel(parent) {
  var self = this;

  // Predicate this ViewModel on the Abstract class of a View Model
  // This tacks on additional functionality, including the ability to
  // read URL query parameters, and an observable binding predicated
  // on another object's obcervable-bound variables
  AbstractViewModel.apply(this, arguments);

  self.locationId = ko.observable(null);
  self.queueId = ko.observable(null);
  self.transactionTypeId = ko.observable(null);

  self.possibleBlocksWS = new PossibleTimeBlocksWS(self.parent);


  /**
   * Invokes the request to get possible blocks
   *
   * @method findAvailability
   * @returns none
   */
  self.findAvailability = function () {
    if (self.queueId()) {
      self.parent.calendarViewType('week');
      self.parent.globalViewType('openavailability');

      self.possibleBlocksWS.reset();
      self.possibleBlocksWS.queueId(self.queueId());

      if (self.transactionTypeId()) {
        self.possibleBlocksWS.transactionTypeIds(self.transactionTypeId());
      }

      self.possibleBlocksWS.doRequest();
    }
  };

  /**
   * Returns locations from the parent
   * Sets the internal location ID if there is only one location
   *
   * @method locations
   * @returns {Array}
   */
  self.locations = ko.computed(function () {
    self.locationId(null);

    if (self.parent && self.parent.selectedLocationIds()) {
      if (self.parent.locations().length === 1) {
        self.locationId(self.parent.locations()[0].id);
      }
      var locs = self.parent.locations().filter(function (loc) {
        return self.parent.selectedLocationIds().indexOf(loc.id.toString()) > -1;
      });

      if (locs.length === 1) {
        self.locationId(locs[0].id);
      }

      return locs;
    }
    return [];
  });


  /**
   * Returns queues for the selected location ID
   * Sets the internal queue ID if there is only one queue
   *
   * @method queues
   * @returns {Array}
   */
  self.queues = ko.computed(function () {
    self.queueId(null);

    if (self.parent && self.parent.queuesWS && self.parent.queuesWS.allQueues()) {
      var queues = self.parent.queuesWS.allQueues().filter(function (q) {
        return q.appointmentsEnabled && (Number(q.locationId) === Number(self.locationId()));
      });

      if (queues.length === 1) {
        self.queueId(queues[0].id);
      }

      return queues;
    }
    return [];
  });


  /**
   * Method to reset the View Model
   *
   * @method reset
   * @returns none
   */
  self.reset = function () {
    self.possibleBlocksWS.reset();
  }


  /**
   * Finds instance of a QueueModel so that Transaction Types can be found
   *
   * @method selectedQueue
   * @returns {QueueModel | Null}
   */
  self.selectedQueue = ko.computed(function () {
    if (self.queueId()) {
      return self.parent.queuesWS.queues().filter(function (q) {

        return Number(q.id) === Number(self.queueId());
      })[0];
    }
    return null;
  });


  /**
   * Returns a collection of Transaction Types
   *
   * @method transactionTypes
   * @returns {Array}
   */
  self.transactionTypes = ko.computed(function () {
    self.transactionTypeId(null);

    if (self.queueId() && self.selectedQueue()) {
      var tts = self.selectedQueue().transactionTypes();

      if (tts.length === 1) {
        self.transactionTypeId(tts[0].id);
      }

      return tts;
    }
    return [];
  });

  return self;
};

OpenAvailabilityViewModel.prototype = AbstractViewModel.prototype;
OpenAvailabilityViewModel.prototype.constructor = OpenAvailabilityViewModel;
